import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/newsletter.css";

createRoot(document.getElementById("root")!).render(<App />);
